import React from "react";
import { useHistory } from "react-router-dom";
import { Grid, Box, Typography, Button } from "@material-ui/core";

import Layout from "../components/Layout/Layout";

function ErrorPage() {
    const history = useHistory();

    return (
        <Layout title={`Error`}>
            <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item>
                    <Typography variant="h2">{`Oops!`}</Typography>
                </Grid>
                <Grid item>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Typography variant="body1">{`Something went wrong at our end.`}</Typography>
                        <Typography variant="body1">{`Please try again.`}</Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Button variant="contained" color="primary" onClick={() => history.replace("/")}>
                        {`Back Home`}
                    </Button>
                </Grid>
            </Grid>
        </Layout>
    );
}

export default ErrorPage;
